var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 3.16667C1.66797 2.72464 1.84356 2.30072 2.15612 1.98816C2.46868 1.67559 2.89261 1.5 3.33464 1.5H8.33464V16.5H3.33464C2.89261 16.5 2.46868 16.3244 2.15612 16.0118C1.84356 15.6993 1.66797 15.2754 1.66797 14.8333V3.16667ZM11.668 1.5H16.668C17.11 1.5 17.5339 1.67559 17.8465 1.98816C18.159 2.30072 18.3346 2.72464 18.3346 3.16667V7.33333H11.668V1.5ZM11.668 10.6667H18.3346V14.8333C18.3346 15.2754 18.159 15.6993 17.8465 16.0118C17.5339 16.3244 17.11 16.5 16.668 16.5H11.668V10.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.0afced4db07ae964a431d6cca7517aad.svg";
export { ForwardRef as ReactComponent };